import { jsx as _jsx } from "react/jsx-runtime";
import { Battery0, Battery1, Battery2, Battery3, Battery4, } from '../../icons/Battery';
const DeviceBatteryState = ({ classes, size = 20, level }) => {
    switch (true) {
        case level === 0:
            return _jsx(Battery0, { classes: classes, size: size }, void 0);
        case level > 0 && level <= 25:
            return _jsx(Battery1, { classes: classes, size: size }, void 0);
        case level > 25 && level <= 50:
            return _jsx(Battery2, { classes: classes, size: size }, void 0);
        case level > 51 && level <= 75:
            return _jsx(Battery3, { classes: classes, size: size }, void 0);
        case level > 75 && level <= 100:
            return _jsx(Battery4, { classes: classes, size: size }, void 0);
        default:
            return null;
    }
};
export default DeviceBatteryState;
